import AnimatingDots from '~/components/AnimatingDots';
import Gap from '~/components/Gap';
import BasicSection from './BasicSection';
import CustomerSection from './CustomerSection';
import styles from './estimateform.module.scss';
import EstimateSettings from './EstimateSettings';
import ItemSection from './ItemSection';
import NotesSection from './NotesSection';
import SummarySection from './SummarySection';
import { useEstimateForm } from './useEstimateForm';

const EstimateForm = () => {
  const { formData, setValue, isLoading } = useEstimateForm({});

  if (isLoading) {
    return (
      <div className="full-dimenstions center">
        <AnimatingDots />
      </div>
    );
  }

  return (
    <div className={`${styles.formContainer} full-width`}>
      <div className={styles.mainForm}>
        <BasicSection formData={formData} setValue={setValue} />
        <Gap t={40} />
        <CustomerSection formData={formData} setValue={setValue} />
        <Gap t={40} />
        <ItemSection formData={formData} setValue={setValue} />
        <SummarySection formData={formData} setValue={setValue} />
        <NotesSection formData={formData} setValue={setValue} />
      </div>

      <EstimateSettings formData={formData} setValue={setValue} />
    </div>
  );
};

export default EstimateForm;
